// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9798c63e","952":"78025bd9"}[chunkId] + ".chunk.js";
};